import { useEffect, useState } from "react";
import type { User } from "../types/user";
import { getUsersApi } from "../api/usersApi";
import Select, { type MultiValue } from "react-select";
import { useTranslation } from "react-i18next";
import type translations from "../translations/translations.json";

type TranslationKeys = keyof typeof translations.en;

interface Option {
  value: string;
  label: string;
}

interface EditorUsersSelectProps {
  value: string[];
  onChange: (editorUserIds: string[]) => void;
}

export const EditorUsersSelect = ({ value, onChange }: EditorUsersSelectProps) => {
  const [users, setUsers] = useState<User[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchUsers = async () => {
      setIsLoading(true);
      setUsers(await getUsersApi());
    };

    fetchUsers();
  }, []);

  const options: Option[] = users.map((user) => ({
    value: user._id,
    label: user.name,
  }));

  const selectedOptions = options.filter((option) => value.includes(option.value));

  const handleChange = (selected: MultiValue<Option>) => {
    const selectedIds = selected ? selected.map((option: Option) => option.value) : [];
    onChange(selectedIds);
  };

  return (
    <Select<Option, true>
      isMulti
      isLoading={isLoading}
      options={options}
      value={selectedOptions}
      onChange={handleChange}
      placeholder={t("Select users who can edit this TruckGroup" as TranslationKeys)}
      className="basic-multi-select"
      classNamePrefix="select"
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 20000 }),
      }}
      menuPortalTarget={document.body}
    />
  );
};
